import { render, staticRenderFns } from "./PAndLView.vue?vue&type=template&id=afab5120&"
import script from "./PAndLView.vue?vue&type=script&lang=js&"
export * from "./PAndLView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports